import { Link, Outlet } from 'react-router-dom';


function Layout() {
    return (
        <div className="app">
            <link
                rel="stylesheet"
                href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css"
            />

            {/* Top Image Header */}
            <div className="hero">
                <div className="hero-overlay">
                    <h1 className="hero-title">M Smith Accounting Professional Corporation</h1>
                    <p className="hero-subtitle">Professional Accounting & Tax Services</p>
                </div>
            </div>


            {/* Navigation Bar */}
            <nav className="nav">
                <Link to="/">Home</Link>
                <Link to="/client-services">Client Services</Link>
                <Link to="/financial-tools">Financial Tools</Link>
                <Link to="/contact">Contact Us</Link>
                <a href='https://msmithaccounting.cchifirm.ca/clientportal/' rel="noopener noreferrer" target="_blank"><i className={`fa-solid fa-envelopes-bulk`}></i> Portal</a>
            </nav>


            {/* Page Content */}
            <main className="content">
                <Outlet />
            </main>


            <footer className="footer">
            © {new Date().getFullYear()} M Smith Accounting Professional Corporation. All rights reserved.
            </footer>
        </div>
    );
}


export default Layout;